import {webClient} from "../../config/axios";

export const deletePasswordRequest = (list) => {
    let deletePromises = []
    list.forEach((passwordId)=>{
        deletePromises.push(webClient.delete(`/user/app-password/${passwordId}`))
    })
    return deletePromises;
};